import { graphql, useStaticQuery } from "gatsby"
import React from "react"

const TestimonialList = ({ module }) => {
    const data = useStaticQuery(graphql`
    query {
        allAgilityTestimonial {
          nodes {
            customFields {
              text
              attribution
            }
          }
        }
    }
  `)

    const testimonials = data.allAgilityTestimonial?.nodes?.map((t) => { return t.customFields }) ?? []

    return (
        <section className="testimonial-list relative mx-auto w-full max-w-screen-xl flex flex-col divide-y">
            {testimonials?.[0] && testimonials.map((testimonial) => (
                <div className="w-full flex flex-col py-8">
                    <div className="block textimonial-text" dangerouslySetInnerHTML={{ __html: testimonial.text }}></div>
                    {testimonial.attribution && <div className="inline testimonial-attribution italic" dangerouslySetInnerHTML={{ __html: testimonial.attribution }}></div>}
                </div>
            ))}
        </section>
    )
}

export default TestimonialList